module.exports = __webpack_public_path__ + "static/media/se_page8.90f70e8b.ogg";